var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoalIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.174 9.74971C13.0384 10.4134 12.7255 11.0279 12.2686 11.5281C11.8117 12.0282 11.2279 12.3952 10.5791 12.5901C9.93036 12.7851 9.24092 12.8006 8.58403 12.6352C7.92715 12.4697 7.32735 12.1294 6.84835 11.6504C6.36935 11.1714 6.02905 10.5716 5.86359 9.91471C5.69813 9.25783 5.71369 8.56839 5.90862 7.91964C6.10355 7.27089 6.47057 6.68705 6.97069 6.23015C7.47081 5.77326 8.08536 5.46036 8.74904 5.32471",
    stroke: "#0BA9F5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.7475 2.25H9.5C8.16498 2.25 6.85994 2.64588 5.7499 3.38758C4.63987 4.12928 3.77471 5.18349 3.26382 6.41689C2.75292 7.65029 2.61925 9.00749 2.8797 10.3169C3.14015 11.6262 3.78303 12.829 4.72703 13.773C5.67104 14.717 6.87377 15.3599 8.18314 15.6203C9.49252 15.8808 10.8497 15.7471 12.0831 15.2362C13.3165 14.7253 14.3707 13.8601 15.1124 12.7501C15.8541 11.6401 16.25 10.335 16.25 9C16.25 8.9175 16.25 8.835 16.25 8.7525M11.75 6.75L9.875 8.625L11.75 6.75ZM11.75 4.5V6.75H14L16.25 4.5H14V2.25L11.75 4.5Z",
    stroke: "#0BA9F5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoalIcon);
export default __webpack_public_path__ + "static/media/goal-icon.20ac78d9aa57b668a2c5287e8a059a99.svg";
export { ForwardRef as ReactComponent };